import PropTypes from "prop-types";
import React from "react";
import { StyleSheet, View, TouchableOpacity, Platform } from "react-native";
import ENV from "app/utils/ENV";

// import ProgressRingOG from 'app/components/ProgressRingOG'
// import ProgressRingChildren from 'app/components/ProgressRingChildren'
// import ProgressRingLayered from 'app/components/ProgressRingLayered'
// import ProgressRingDotted from 'app/components/ProgressRingDotted'
// import ProgressRingFresh from "app/components/ProgressRingFresh";
import ProgressRingTimeline from "app/components/ProgressRingTimeline";
import ProgressRingSimplified from "app/components/ProgressRingSimplified";

export default class ProgressRing extends React.Component {
  render() {
    const Elem = this.props.simplified
      ? ProgressRingSimplified
      : ProgressRingTimeline;
    return <Elem {...this.props} />;
  }
}
